import PropTypes from 'prop-types'

import clsx from 'clsx'
import Check from '@material-ui/icons/Check'

import { useStepIconStyles } from './styles'

const StepIcon = (props) => {
  const classes = useStepIconStyles()
  const { active, completed } = props

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle}>
          <div />
        </div>
      )}
    </div>
  )
}

StepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
}

export default StepIcon
